export default __webpack_public_path__ + "static/media/bg-06.51b4ae1c.jpg";